import { StyledIconContainer, Icon, StyledTypography } from "./StyledComponents";
import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import { Truncate } from "@kaltura/mediaspace-shared-ui";
import { Tooltip } from "@kaltura/ds-react-components";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

export interface Channel {
    name: string;
    url: string;
    iconUrl: string;
    createdAt: number;
    membersCount: number;
    entriesCount: number;
    updatedAt: number;
    order?: number;
}

export interface ChannelIconProps {
    channel: Channel;
    itemsInLine: number;
    disableEntitlements: boolean;
}

const ChannelIcon = (props: ChannelIconProps) => {
    const { channel, itemsInLine, disableEntitlements } = props;
    const { iconUrl, url, name } = channel;

    const sendButtonAnalytics = useButtonAnalytics();

    return (
        <StyledIconContainer
            href={url}
            disableEntitlements={disableEntitlements}
            itemsInLine={itemsInLine}
            onClick={() =>
                sendButtonAnalytics(
                    "Channels collection component - channel thumbnail",
                    ButtonClickAnalyticsType.THUMBNAIL
                )
            }
        >
            <Icon style={{ backgroundImage: `url(${iconUrl})` }} itemsInLine={itemsInLine} />
            <Tooltip title={name} placement={"top"}>
                <StyledTypography variant={"body1"} component={"h3"}>
                    <Truncate lines={2} showMore={false}>
                        {HtmlReactParser(name)}
                    </Truncate>
                </StyledTypography>
            </Tooltip>
        </StyledIconContainer>
    );
};

export default ChannelIcon;
